import { QueryLevel } from "csi/view/_query/Level";
import declare from "dojo/_base/declare";
import AggregateFromRecipeBaseProductTableMixin from "./AggregateFromRecipeBaseProductTableMixin";
import xml from "csi/xml";

const FOOD_SUBTYPE = "FoodSubtype";
const SUBTYPE = "Subtype";

const AggregateFromRecipeFoodTable = declare(AggregateFromRecipeBaseProductTableMixin, {

	/**
	 * @override
	 * Add filter for selected Food Type
	 */
	onCreateMainQueryLevel(ql: QueryLevel): void {
		this.modifyQuery(FOOD_SUBTYPE, SUBTYPE, ql);
		// Add filters for Foods that support recipe
		const query = ql.serverQuery;
		if (query){
			query.Attr("TDSList", xml.OP_EQUALS, "FoodTypeDataSheet:RecipeDataSheet", "Child:Subtype/Child:Settings");
		}
		this.modifyQueryRemoveParentProduct(ql);
	},
});

export = AggregateFromRecipeFoodTable;